import ToolBar from '@/components/ToolBar';
import { useCourtPost } from '@brainvaulttech/dgr-react-sdk';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';
import { CourtForm, CourtSchema } from './CourtForm';
import AlertBox from '@/components/AlertBox';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/components/ui/use-toast';
import { displayError } from '@/lib/error';

const CourtCreate = ({
  displayType = 'PAGE',
  onSave,
  onClose,
}: {
  displayType?: 'PAGE' | 'MODAL';
  onClose?: () => void;
  onSave?: () => void;
}) => {
  const [isAlertBoxOpen, setIsAlertBoxOpen] = useState(false);
  const [isCancelAlertOpen, setIsCancelAlertOpen] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();
  const form = useForm<z.infer<typeof CourtSchema>>({
    resolver: zodResolver(CourtSchema),
    mode: 'onBlur',
  });

  const { isValid } = form.formState;
  const { mutate: createCourt, status } = useCourtPost();

  const handleSubmit = () => {
    createCourt(
      { data: form.getValues() },
      {
        onSuccess: (data) => {
          setIsAlertBoxOpen(false);
          displayType === 'PAGE' && navigate('/courts');
          onSave && onSave();
          toast({
            variant: 'default',
            description: data.data.message,
          });
        },
        onError: (e) => {
          setIsAlertBoxOpen(false);
          displayError(e, 5000);
        },
      }
    );
  };
  return (
    <>
      <div className="flex flex-col w-full">
        {displayType === 'PAGE' && <ToolBar title="Add New Court" />}
        <div className="flex flex-col gap-6">
          <FormProvider {...form}>
            <CourtForm displayType={displayType} />
          </FormProvider>
          <div
            className={`flex flex-row gap-6 pb-8 ${displayType === 'PAGE' ? 'justify-start' : 'justify-end'} ${displayType === 'MODAL' ? 'sticky bottom-0 bg-white' : ''}`}
          >
            <AlertBox
              triggerButton={
                <Button
                  type="button"
                  variant="outline"
                  className="text-primary w-[75px] h-[36px] py-2 px-4 rounded-md focus:outline-none border-primary hover:bg-[#EDF5FF]"
                  onClick={() => setIsCancelAlertOpen(true)}
                >
                  Cancel
                </Button>
              }
              title="Are you sure you want to cancel?"
              description={'All of your current changes will be lost.'}
              warning={true}
              cancelBtnLabel="No"
              confirmBtnLabel="Yes"
              cancelBtnClick={() => {
                setIsCancelAlertOpen(false);
              }}
              confirmBtnClick={() => {
                setIsCancelAlertOpen(false);
                displayType === 'PAGE' ? navigate('/courts') : onClose && onClose();
              }}
              open={isCancelAlertOpen}
            />
            <AlertBox
              triggerButton={
                <Button
                  variant="outline"
                  className="text-[#fff] h-[36px] w-[103px] py-2 px-4 rounded-md bg-primary border-primary hover:bg-[#12375C] hover:text-white"
                  disabled={!isValid}
                  onClick={() => setIsAlertBoxOpen(true)}
                >
                  Save
                </Button>
              }
              title={`Do you want to save the record?`}
              description={`This action will create a new court record in the database.`}
              cancelBtnLabel="Cancel"
              confirmBtnLabel="Save"
              open={isAlertBoxOpen}
              isLoading={status === 'pending'}
              cancelBtnClick={() => setIsAlertBoxOpen(false)}
              confirmBtnClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CourtCreate;
